import { useMenuStore } from 'vince-core/stores/menuStore';
import { Menu, SubHeader } from 'vince-core/types/menu';
import { ResourceType } from 'vince-core/types/common';
import { Action } from 'vince-core/types/roles';

export default defineNuxtPlugin(() => {
    const store = useMenuStore();
    store.addMenuItem('m3WorkflowBuilder.menuLabel', '/tools/m3-metadata', 1, Menu.ADMINISTRATION, SubHeader.WORKFLOW_MANAGEMENT, undefined, {
        app: VinceApp.FND,
        resource: ResourceType.WORKFLOW,
        resourceId: '*',
        action: Action.WRITE
    });
});
